import ResolveChatsMenu from './ResolveChatsMenu';
export default ResolveChatsMenu;
